import { render, staticRenderFns } from "./homeyuyue.vue?vue&type=template&id=3143cb4d&scoped=true"
import script from "./homeyuyue.vue?vue&type=script&lang=js"
export * from "./homeyuyue.vue?vue&type=script&lang=js"
import style0 from "./homeyuyue.vue?vue&type=style&index=0&id=3143cb4d&prod&lang=css"
import style1 from "./homeyuyue.vue?vue&type=style&index=1&id=3143cb4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3143cb4d",
  null
  
)

export default component.exports